/**
 * Input Components
 */

import InputText from './InputText';
import type { IInputTextProps } from './InputText/_props';

import InputTextarea from './InputTextarea';
import type { IInputTextareaProps } from './InputTextarea/_props';

import InputDropdown from './InputDropdown';
import type { IInputDropdownProps } from './InputDropdown/_props';

/**
 * Input Namespace
 */

const Input = <TFormFields extends Record<string, unknown>>() => ({
  Text: InputText<TFormFields>,
  Textarea: InputTextarea<TFormFields>,
  Dropdown: InputDropdown<TFormFields>,
});

/**
 * Exports
 */

export { IInputTextProps, IInputTextareaProps, IInputDropdownProps };

export default Input;
